import { ReactNode } from "react";

import { Backdrop } from "~/ui/base/Backdrop";
import { Layer } from "~/ui/provider/StackedLayerProvider";

const StackedPage = ({
  children,
  close,
  descriptionId,
  titleId,
  visible,
}: Omit<Parameters<Layer>[0], "context"> & {
  children: ReactNode;
}) => {
  return (
    <Backdrop
      close={close}
      descriptionId={descriptionId}
      titleId={titleId}
      visible={visible}
    >
      <div
        className={`fixed inset-0 z-40 overflow-y-scroll bg-white dark:bg-zinc-950 ${
          visible ? "animate-stacked-layer-from" : "animate-stacked-layer-to"
        }`}
      >
        <div className="mobile-column h-full bg-white dark:bg-zinc-950">
          {children}
        </div>
      </div>
    </Backdrop>
  );
};

export const createStackedPage = (Content: Layer): Layer => {
  if (import.meta.env.DEV) {
    console.warn("StackedPage is created. This must be created once.");
  }

  const Component = (({ close, context, descriptionId, titleId, visible }) => (
    <StackedPage
      close={close}
      descriptionId={descriptionId}
      titleId={titleId}
      visible={visible}
    >
      <Content
        close={close}
        context={context}
        descriptionId={descriptionId}
        titleId={titleId}
        visible={visible}
      />
    </StackedPage>
  )) satisfies Layer;
  return Component;
};
